/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-unused-vars */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import { isMobile, isAndroid, isIOS } from 'react-device-detect';

class BarBannerItem extends Component {
  state = {};
  componentDidMount = () => {
    const { idx, adComIdx, pageCode } = this.props.childProps;
    //console.log('barbanner ==>' + idx)
    if (adComIdx !== 1) {
      this._bannerView(idx, adComIdx, pageCode);
    }
  };
  _bannerView = async (idx, adComIdx, pageCode) => {
    if (adComIdx === null || adComIdx === undefined || adComIdx === '') {
    } else {
      if (adComIdx !== 1) {
        const result = await this._bannerViewApi(idx, adComIdx, pageCode);
        const intReturn = result.data[0].intReturn;

        if (intReturn === 0) {
          //console.log('banner view history...')
        }
      }
    }
  };

  _bannerViewApi = (idx, adComIdx, pageCode) => {
    const { apiUrl, loginId } = this.props;

    return axios.post(apiUrl + '/bannerView', {
      params: {
        userid: loginId,
        idx: idx,
        adComIdx: adComIdx,
        pageCode: pageCode,
      },
    });
  };
  _bannerClickApi = (idx, adComIdx, pageCode) => {
    const { apiUrl, loginId } = this.props;

    return axios.post(apiUrl + '/bannerClick', {
      params: {
        userid: loginId,
        idx: idx,
        adComIdx: adComIdx,
        pageCode: pageCode,
      },
    });
  };
  _onClick = async () => {
    const { history, setEventIdx } = this.props;
    const {
      LinkURL,
      Linktarget,
      LinkURL_M,
      Linktarget_M,
      idx,
      comment,
      adComIdx,
      pageCode,
    } = this.props.childProps;
    //console.log(idx, LinkURL, comment)
    //console.log(Linktarget)
    //console.log(comment)
    if (adComIdx !== 1) {
      const result = await this._bannerClickApi(idx, adComIdx, pageCode);
      const intReturn = result.data[0].intReturn;
    }
    console.log(LinkURL_M, idx, pageCode);
    if (comment === 'event') {
      //alert(LinkURL)
      //console.log(LinkURL)

      if (isMobile) {
        setEventIdx(parseInt(LinkURL_M));
      } else {
        setEventIdx(parseInt(LinkURL));
      }
    } else {
      if (isMobile) {
        if (Linktarget_M === '_self') {
          history.push(LinkURL_M);
        } else {
          window.open(LinkURL_M, '', '');
        }
      } else {
        if (Linktarget === '_self') {
          history.push(LinkURL);
        } else {
          window.open(LinkURL, '', '');
        }
      }
    }
  };
  _bannerClickApi = (idx, adComIdx, pageCode) => {
    const { apiUrl, loginId } = this.props;

    return axios.post(apiUrl + '/bannerClick', {
      params: {
        userid: loginId,
        idx: idx,
        adComIdx: adComIdx,
        pageCode: pageCode,
      },
    });
  };
  render() {
    const { wSize, wSizeRatio, hSize } = this.state;
    const { index, bannerFile, LinkURL, Linktarget, bannerFile_s } =
      this.props.childProps;
    console.log(bannerFile_s);
    return (
      <Fragment>
        <div
          className={
            isMobile ? `promotion_divm${index}` : `promotion_div${index}`
          }
          onClick={this._onClick}
          style={{ cursor: 'pointer' }}
        >
          <img
            src={`https://bc8azosk4j.ecn.cdn.ofs.kr/aniplustv/banner/${
              isMobile ? bannerFile_s : bannerFile
            }`}
            style={{ width: '100%' }}
          />
        </div>
        {/*
                <div onClick={this._onClick}>
                    <img src = {'https://bc8azosk4j.ecn.cdn.ofs.kr/aniplustv/banner/' + bannerFile} />
                </div>
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(BarBannerItem));
